"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@21st-night/core");
var core_2 = require("@material-ui/core");
var DeckImportFromQuizlet_1 = __importDefault(require("../DeckImportFromQuizlet"));
var Button_1 = __importDefault(require("../../Button"));
var DeckImportFromQuizletContainer = function (_a) {
    var loading = _a.loading, onCancel = _a.onCancel, onSubmit = _a.onSubmit, other = __rest(_a, ["loading", "onCancel", "onSubmit"]);
    var _b = core_1.useForm({
        columnSeparator: 'tab',
        columnSeparatorCustom: ' - ',
        rowSeparator: 'new-line',
        rowSeparatorCustom: '\\n\\n',
        text: '',
    }), values = _b.values, onFieldChange = _b.onFieldChange, setValues = _b.setValues;
    var handleSubmit = react_1.useCallback(function () {
        var rowSeparator = values.rowSeparatorCustom;
        var columnSeparator = values.columnSeparatorCustom;
        if (values.rowSeparator === 'new-line') {
            rowSeparator = '\n';
        }
        else if (values.rowSeparator === 'semicolon') {
            rowSeparator = ';';
        }
        if (values.columnSeparator === 'tab') {
            columnSeparator = '	';
        }
        else if (values.columnSeparator === 'comma') {
            columnSeparator = ',';
        }
        onSubmit(values.text, rowSeparator, columnSeparator);
    }, [
        onSubmit,
        values.columnSeparator,
        values.columnSeparatorCustom,
        values.rowSeparator,
        values.rowSeparatorCustom,
        values.text,
    ]);
    return (react_1.default.createElement(core_2.Dialog, __assign({ fullWidth: true, maxWidth: "xs" }, other),
        react_1.default.createElement(core_2.DialogTitle, null, "Import from Quizlet"),
        react_1.default.createElement(core_2.DialogContent, null,
            react_1.default.createElement(DeckImportFromQuizlet_1.default, { onFieldChange: onFieldChange, values: values, onFocusColumnSeparatorCustom: function () {
                    setValues({ columnSeparator: 'custom' });
                }, onFocusRowSeparatorCustom: function () {
                    setValues({ rowSeparator: 'custom' });
                } })),
        react_1.default.createElement(core_2.DialogActions, null,
            react_1.default.createElement(Button_1.default, { onClick: onCancel }, "Cancel"),
            react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: handleSubmit, disabled: loading }, loading ? 'Importing...' : 'Import'))));
};
exports.default = DeckImportFromQuizletContainer;
//# sourceMappingURL=DeckImportFromQuizletContainer.js.map